export function Memoize(memoizationDuration?: number) {
    return (_: any, functionName: string, descriptor: any) => {
        const functionReference = descriptor.value;
        const memoizationMapSymbol = Symbol(functionName);
        descriptor.value = function (...args: any[]) {
            if (!this[memoizationMapSymbol]) {
                this[memoizationMapSymbol] = new Map<string, any>();
            }

            const argsKey = JSON.stringify([...args]);
            const now = Temporal.Now.instant();

            if (
                this[memoizationMapSymbol].has(argsKey) &&
                (!memoizationDuration ||
                    now.since(this[memoizationMapSymbol].get(argsKey).time).total('milliseconds') < memoizationDuration)
            ) {
                return this[memoizationMapSymbol].get(argsKey).value;
            } else {
                const functionValue = functionReference.apply(this, args);
                this[memoizationMapSymbol].set(argsKey, {
                    time: now,
                    value: functionValue
                });
                return functionValue;
            }
        };
        return descriptor;
    };
}
